import { CommandsBase } from './base';
import { Boards } from 'src/api';

export namespace Postings {
  export namespace Types {
    export type BoardActionProps = Boards.Types.BoardActionProps;

    export interface PostingActionProps {
      postingId: string;
    }

    export type ActionResponse = {
      executionArn: string;
      startDate: string;
    };

    export interface PostingAction {
      created: string; //"2022-12-02T11:01:30.139Z",
      type: string; //"ADD",
      status: string; // "RECEIVED"
    }
    export interface PostingAuth {
      password: string;
      username: string;
    }
    export interface Posting {
      id: string; // "1235-1706-ea3f0e44",
      jobId: number;
      boardId: 1706;
      mediaId: number;
      packageId: number;
      packageName: string;
      recruiterId: number;
      company: string;
      country: string;
      state: string;
      zip: string; // "06901"
      requirements: string;
      name: string;
      function: string;
      position: string;
      auth: PostingAuth;
      actions: PostingAction[];
      lastAction: PostingAction;
      createdAt: string; //"2022-12-02T11:01:30.139",
      expires: string; //"2020-11-15T00:00:00.000Z",
      description: string;
      jobType: string;
      travel: string;
    }

    export interface FindPostingsProps {
      id?: string;
      name?: string;
      boardId?: string; //number;
      jobId?: string; //number;
      oldId?: string; //number;
      atsPartner?: string;
      eaHash?: string;
      cpc?: string; //boolean;
    }

    export type DetailsData = Record<string, unknown>; // huge piece of data should be imported from SDK
    export type FindPostingsData = Posting[];

    export interface PostingProof {
      url: string;
      createdAt: string;
    }

    export type PostingSnapshot = PostingProof;
  }

  export const SERVICE = 'postings';
  export const ACTIONS = {
    validate: 'validate',
    deliver: 'deliver',
    search: 'search',
    getById: 'getById',
    proofs: 'proofs',
    snapshots: 'snapshots',
    // details: 'details',
    // create: 'create',
    // list: 'list',
  };
  export const SKIP_EVENTS = Object.values(ACTIONS);

  export class Commands extends CommandsBase {
    validate(data: Types.BoardActionProps) {
      return this.client.execute<typeof data, Types.ActionResponse>(
        this.command(ACTIONS.validate),
        data
      );
    }

    deliver(data: Types.BoardActionProps) {
      return this.client.execute<typeof data, Types.ActionResponse>(
        this.command(ACTIONS.deliver),
        data
      );
    }

    search(data: Types.FindPostingsProps) {
      return this.client.execute<typeof data, Types.FindPostingsData>(
        this.command(ACTIONS.search),
        data
      );
    }

    getById(data: Types.PostingActionProps) {
      return this.client.execute<typeof data, Types.Posting>(
        this.command(ACTIONS.getById),
        data
      );
    }

    getProofs(data: Types.PostingActionProps) {
      return this.client.execute<typeof data, Types.PostingProof[]>(
        this.command(ACTIONS.proofs),
        data
      );
    }

    getSnapshots(data: Types.PostingActionProps) {
      return this.client.execute<typeof data, Types.PostingSnapshot[]>(
        this.command(ACTIONS.snapshots),
        data
      );
    }

    // details(props: Types.DetailsProps) {
    //   return this.client.execute<Types.DetailsProps, Types.DetailsData>(
    //     this.command(ACTIONS.details),
    //     props
    //   );
    // }

    // list() {
    //   return this.client.execute(this.command(ACTIONS.list), {});
    // }
    //
    // create(props: Types.CreateProps) {
    //   return this.client.execute<Types.CreateProps, Types.CreateData>(
    //     this.command(ACTIONS.create),
    //     props
    //   );
    // }
  }
}
